import { resolvePpcAmpelHex, formatPpcDelta } from '@/utils/cockpitDisplay';

export function formatSignedDelta(value, suffix = '') {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return null;
  const num = Number(value);
  const sign = num > 0 ? '+' : '';
  return `${sign}${num}${suffix}`;
}

export function impactPpcBars(history = []) {
  return (history || []).map((entry) => ({
    label: entry.label,
    ppc: entry.ppc,
    n: entry.n,
    periodKey: entry.periodKey,
  }));
}

export function impactTbiBars(history = []) {
  return (history || []).map((entry) => ({
    label: entry.label,
    tbi: entry.tbi,
    n: entry.n,
    periodKey: entry.periodKey,
  }));
}

export function formatShortDate(value) {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString(undefined, { day: '2-digit', month: '2-digit' });
}

export function causeBarWidth(count, maxCount) {
  if (!maxCount || !count) return 0;
  return Math.max(4, Math.round((count / maxCount) * 100));
}

export function maxCauseCount(distribution = []) {
  return Math.max(0, ...((distribution || []).map((row) => row.count || 0)));
}

export function resolveImpactAmpel(value, thresholds = { greenMin: 80, yellowMin: 60 }) {
  return resolvePpcAmpelHex(value, thresholds);
}

export function formatImpactDelta(delta, unit = '') {
  return formatPpcDelta(delta, unit);
}

export function milestoneStatusIcon(milestone = {}) {
  if (milestone.status === 'done') return '✓';
  if (milestone.isOverdue || milestone.ampel === 'red' || milestone.status === 'at_risk') return '◉';
  return '○';
}

export function milestoneStatusColor(milestone = {}) {
  if (milestone.status === 'done') return 'var(--color-success, #22C55E)';
  if (milestone.isOverdue || milestone.ampel === 'red') return 'var(--color-error, #EF4444)';
  if (milestone.ampel === 'yellow' || milestone.status === 'at_risk') return '#EAB308';
  return '#ABABAB';
}
